import { VotingConstants } from "../../constants/voting.constants";
import { authHeader } from "../../../../helpers/auth-header";
import { client } from "../../../../actions";
import bindsToAddresses from "../../utils/bindsToAddresses";
import { message } from "antd";
import fileIsImage from "../../utils/fileIsImage";

const uri = "/Voting";

const getVotingFiles = async (votingId) => {
	const response = await client.get(`${uri}/attachments/${votingId}`, {
		headers: authHeader(),
	});
	return response.data.sort(
		(firstFile, secondFile) =>
			fileIsImage(secondFile.name) - fileIsImage(firstFile.name)
	);
};

const getAnswerFiles = async (id) => {
	const response = await client.get(`${uri}/item_attachments/${id}`, {
		headers: authHeader(),
	});
	return response.data.sort(
		(firstFile, secondFile) =>
			fileIsImage(secondFile.name) - fileIsImage(firstFile.name)
	);
};

const getAnswers = async (questionId) => {
	const res = [];
	const response = await client.get(`${uri}/items`, {
		headers: authHeader(),
		params: { questionId },
	});
	await Promise.all(
		response.data.map(async (answer) => {
			const files = await getAnswerFiles(answer.id);
			res.push({ ...answer, files });
		})
	);
	return res.sort((el1, el2) => {
		return el1.orderNum - el2.orderNum;
	});
};

const getQuestionFiles = async (id) => {
	const response = await client.get(`${uri}/question_attachments/${id}`, {
		headers: authHeader(),
	});
	return response.data.sort(
		(firstFile, secondFile) =>
			fileIsImage(secondFile.name) - fileIsImage(firstFile.name)
	);
};

const getQuestions = async (votingId) => {
	const res = [];
	const response = await client.get(`${uri}/questions`, {
		params: { votingId },
		headers: authHeader(),
	});
	await Promise.all(
		response.data.map(async (question) => {
			const answers = await getAnswers(question.id);
			const files = await getQuestionFiles(question.id);
			res.push({ ...question, answers, files });
		})
	);

	return res.sort((el1, el2) => {
		return el1.orderNum - el2.orderNum;
	});
};

const getAddresses = async (id) => {
	const response = await client.get(`${uri}/binds/${id}`, {
		headers: authHeader(),
	});
	return response.data;
};

export const getOneVoting = (id) => async (dispatch, getState) => {
	try {
		dispatch({ type: VotingConstants.GET_ONE_VOTING });
		const response = await client.get(`${uri}/${id}`, {
			headers: authHeader(),
		});
		const attachments = await getVotingFiles(id);
		const questions = await getQuestions(id);
		const addressesResponse = await getAddresses(id);
		if (!response.data.length) {
			dispatch({
				type: VotingConstants.GET_ONE_VOTING_SUCCESS,
				payload: null,
			});
		} else {
			dispatch({
				type: VotingConstants.GET_ONE_VOTING_SUCCESS,
				payload: {
					...response.data[0],
					attachments,
					addresses: bindsToAddresses(addressesResponse, getState),
					binds: addressesResponse,
					questions,
				},
			});
		}
	} catch (e) {
		console.error(e);
		message.error("Не получилось загрузить опрос, попробуйте позже");
	}
};
